import SWLRIFileManagerBrowseFilter from './components/FileManagerBrowseFilter.js';
import SWLRIFileManagerBrowseList from "./components/FileManagerBrowseList.js";
import { fileManagerBrowse, utils } from "./modules/FileManagerBrowse.js"; 

window.addEventListener('swlri-browse-module-loaded',()=>{
    window.customElements.define('swlri-file-manager-browse-file-filter', SWLRIFileManagerBrowseFilter);
    window.customElements.define('swlri-file-manager-browse-file-list', SWLRIFileManagerBrowseList);
})